// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.less
// module id = 511
// module chunks = 0